<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link
          v-if="checkPermission('create_filiere_niveau_matiere') || isAdmin"
          to="/ajouter-filiereNiveauMatiere"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter une filière par niveau
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher une filière" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>

      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Filiere
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Niveau
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Matière
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Coefficient
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(filiereNiveauMatiere, index) in filiereNiveauMatieres" :key="index">
              <td class="shadow-none lh-1 fw-medium ">{{ filiereNiveauMatiere?.filiere?.libelle }} </td>
              <td class="shadow-none lh-1 fw-medium ">{{ filiereNiveauMatiere?.niveau?.libelle }} </td>
              <td class="shadow-none lh-1 fw-medium ">{{ filiereNiveauMatiere?.matiere?.libelle }} </td>
              <td class="shadow-none lh-1 fw-medium ">{{ filiereNiveauMatiere.coefficient }} </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="['badge', getStatutBadge(filiereNiveauMatiere.statut).class]">
                  {{ getStatutBadge(filiereNiveauMatiere.statut).text }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium">{{ format_date(filiereNiveauMatiere.createdAt) }} </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">

                    <li>
                      <router-link class="dropdown-item d-flex align-items-center"
                        :to="{ name: 'EditFiliereNiveauMatierePage', params: { id: filiereNiveauMatiere.id } }">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </router-link>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="suppression(filiereNiveauMatiere.id, filiereNiveauMatieres, 'filiereNiveauMatieres', 'un coefficient de la filière ' + filiereNiveauMatiere?.filiere?.libelle + ' pour le niveau ' + filiereNiveauMatiere?.niveau?.libelle + ' et la matière ' + filiereNiveauMatiere?.matiere?.libelle)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import ApiService from "@/services/ApiService";
import { FiliereNiveauMatiere } from "@/models/FiliereNiveauMatiere";
import { format_date, suppression, error } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { useAuthStore } from "@/services/auth";

export default defineComponent({
  name: "ListeFiliereNiveauMatiere",
  components: {
    PaginationComponent
  },
  setup() {
    const authStore = useAuthStore();

    const isProfesseur = computed(() => !!authStore.user?.professeur?.id);
    const isEtudiant = computed(() => !!authStore.user?.etudiant?.id);

    const privileges = computed<string[]>(() => {
      return JwtService.getPrivilege() || [];
    });

    const isAdmin = computed(() => {
      return privileges.value.includes('admin') || privileges.value.includes('superadmin');
    });

    onMounted(() => {
      getAllFiliereNiveauMatiere();
    });

    const filiereNiveauMatieres = ref<FiliereNiveauMatiere[]>([]);
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      page.value = page_;
      limit.value = limit_;
      getAllFiliereNiveauMatiere(page_, limit_);
    };

    
     function rechercher(){
      getAllFiliereNiveauMatiere(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getAllFiliereNiveauMatiere(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/filiereNiveauMatieres?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          filiereNiveauMatieres.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
      });
    }
    

    // function getAllFiliereNiveauMatiere(page = 1, limi = 10, searchTerm = "") {
    //   const query = searchTerm.trim() ? `&mot=${encodeURIComponent(searchTerm.trim())}` : "";
    //   return ApiService.get(`/filiereNiveauMatieres?page=${page}&limit=${limi}${query}`)
    //     .then(({ data }) => {
    //       filiereNiveauMatieres.value = data.data.data;
    //       totalPages.value = data.data.totalPages;
    //       limit.value = data.data.limit;
    //       totalElements.value = data.data.totalElements;
    //     })
    //     .catch(({ response }) => {
    //       error(response?.data?.message || "Erreur lors du chargement des compositions");
    //       filiereNiveauMatieres.value = [];
    //     });
    // }

    // function rechercher() {
    //   page.value = 1;
    //   getAllFiliereNiveauMatiere(page.value, limit.value, searchTerm.value);
    // }

    const getStatutBadge = (statut: number | undefined) => {
      switch (statut) {
        case 1: return { class: 'bg-success text-white', text: 'Actif' };
        case 0: return { class: 'bg-danger text-white', text: 'Inactif' };
        default: return { class: 'bg-secondary text-white', text: 'Inconnu' };
      }
    };

    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    return {
      filiereNiveauMatieres,
      searchTerm,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      getAllFiliereNiveauMatiere,
      getStatutBadge,
      format_date,
      suppression,
      checkPermission,
      isProfesseur,
      isEtudiant,
      isAdmin
    };
  },
});
</script>